"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbTimeOut = void 0;
// Events
const events_1 = require("../../features/events");
// Types
const types_1 = require("../../features/timeOut/types");
// Helpers
const timeOut_helper_1 = require("../../features/timeOut/helpers/timeOut.helper");
const timeOut_1 = require("../../features/events/timeOut");
class MbTimeOut {
    constructor(session, authenticator, eventBus) {
        var _a, _b;
        this.initialTimer = -1;
        this.warningInterval = -1;
        this.timeFrame = timeOut_helper_1.INITIAL_TIME_FRAME;
        this.initTimeOutData = (data) => {
            this.clearTimer();
            if ((data === null || data === void 0 ? void 0 : data.expiresIn) && (data === null || data === void 0 ? void 0 : data.timeOutStamp)) {
                this.data = Object.assign(Object.assign({}, types_1.INITIAL_STATE), { countDown: (0, timeOut_helper_1.getCountdown)(data.timeOutStamp) });
                this.timeOutStamp = data.timeOutStamp;
                (0, timeOut_1.publishUpdatedDataTimeOutEvent)(this.data, this.eventBus);
            }
            else {
                this.data = Object.assign({}, types_1.INITIAL_STATE);
                this.timeOutStamp = null;
            }
        };
        this.data = types_1.INITIAL_STATE;
        this.session = session;
        this.authenticator = authenticator;
        this.timeOutStamp = (_b = (_a = session.getData()) === null || _a === void 0 ? void 0 : _a.timeOutStamp) !== null && _b !== void 0 ? _b : null;
        this.initTimeOutData(this.session.getData());
        this.eventBus = eventBus;
        (0, events_1.subscribeUpdatedDataSessionEvent)((data) => {
            data && this.initTimeOutData(data);
        }, this.eventBus);
    }
    setUpdate(callback) {
        (0, timeOut_1.subscribeUpdatedDataTimeOutEvent)(callback, this.eventBus);
    }
    checkTimeOut() {
        (0, events_1.subscribeErrorRefreshingSessionEvent)(() => {
            this.expireTimeout();
        }, this.eventBus);
        this.clearTimer();
        this.data.countDown = (0, timeOut_helper_1.getCountdown)(this.timeOutStamp);
        if (this.data.countDown > types_1.TimeOutCountDown.AT_ZERO) {
            this.createTimer();
        }
        else {
            this.expireTimeout();
        }
    }
    createTimer() {
        this.data.countDown = (0, timeOut_helper_1.getCountdown)(this.timeOutStamp);
        if (this.data.countDown > types_1.TimeOutCountDown.LAST_MINUTE) {
            this.startInitialTimer();
        }
        else {
            this.startWarningInterval();
        }
    }
    startInitialTimer() {
        this.timeFrame = (0, timeOut_helper_1.getDynamicTimeFrame)(this.timeOutStamp);
        this.initialTimer = setTimeout(() => {
            this.checkTimeOut();
        }, this.timeFrame); // recursive timeout
    }
    startWarningInterval() {
        this.warningInterval = setInterval(() => {
            if (this.data.countDown <= types_1.TimeOutCountDown.AT_ZERO) {
                this.expireTimeout();
            }
            else {
                this.data = { isExpired: false, isWarning: true, countDown: (0, timeOut_helper_1.getCountdown)(this.timeOutStamp) };
                (0, timeOut_1.publishUpdatedDataTimeOutEvent)(this.data, this.eventBus);
            }
        }, timeOut_helper_1.FINAL_TIME_FRAME);
    }
    clearTimer() {
        if (this.initialTimer) {
            clearTimeout(this.initialTimer);
        }
        clearInterval(this.warningInterval);
    }
    expireTimeout() {
        this.data = Object.assign(Object.assign({}, this.data), { isExpired: true, isWarning: false });
        this.doFinnish();
        this.clearTimer();
        (0, timeOut_1.publishUpdatedDataTimeOutEvent)(this.data, this.eventBus);
    }
    doRefresh() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.session.refresh();
                this.initTimeOutData(this.session.getData());
                this.checkTimeOut();
            }
            catch (error) {
                console.error('Error refreshing');
            }
        });
    }
    doFinnish() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if ((_b = (_a = this.session) === null || _a === void 0 ? void 0 : _a.getData()) === null || _b === void 0 ? void 0 : _b.accessToken) {
                try {
                    yield this.authenticator.logout();
                }
                catch (error) {
                    console.error('Error logout');
                }
            }
        });
    }
}
exports.MbTimeOut = MbTimeOut;
//# sourceMappingURL=timeout.js.map